var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAddressEditable && (! _vm.isAddressComplete || ! _vm.hasAddress))?_c('b-alert',{attrs:{"variant":"warning","show":""}},[_vm._v(" "+_vm._s(_vm.hasAddress ? "Adres onvolledig!" : "Onbekend adres!")+" "),_c('br'),_c('small',[_vm._v("Er missen adresgegevens, wilt u deze a.u.b. aanvullen?")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }